export const environment = {
    version: '1.92.0.0',

    api: window['env']?.api || 'https://api.app.partsfy.com.br',
    apiBuyer: window['env']?.apiBuyer || 'https://api.buyer.partsfy.com.br',
    apiCommerce: window['env']?.apiCommerce || 'https://api.commerce.partsfy.com.br',
    apiSeller: window['env']?.apiSeller || 'https://api.seller.partsfy.com.br',
    apiSupport: window['env']?.apiSupport || 'https://api.support.partsfy.com.br',
    auth: window['env']?.auth || 'https://auth.partsfy.com.br',
    imageUrl: {
        partsfy: `${window['env']?.imagePath || 'https://cotexo2files.blob.core.windows.net'}/fotos`,
        mercadoPartsfy: `${window['env']?.imagePath || 'https://cotexo2files.blob.core.windows.net'}/mercado-partsfy`
    },

    legalDocumentsUrl: `${window['env']?.imagePath || 'https://cotexo2files.blob.core.windows.net'}/documentos-legais`,

    crispWebsiteId: window['env']?.crispWebsiteId ?? 'ea9e7131-c928-48eb-9a9d-2e78e79fa920',
    directWhatsappIntegration: window['env']?.directWhatsappIntegration ?? true,
    enableSignalRLog: window['env']?.enableSignalRLog ?? false,
    enablePliq: window['env']?.enablePliq ?? false,
    enableUserVerification: window['env']?.enableUserVerification ?? false,
    enableUserVerificationCloseButton: window['env']?.enableUserVerificationCloseButton ?? false,
    googleAnalyticsKey: window['env']?.googleAnalyticsKey ?? 'G-BGE34RDX6M',
    inMaintenance: window['env']?.inMaintenance ?? false,
    production: true,
    useCrypt: window['env']?.useCrypt ?? false
};
